import lodash from 'lodash'
import { addendumChangeType, discountTypes } from '@/utils/locale'
import store from '@/store/index'
import i18n from './i18n'

export const ADDENDUM_CLASS_NAME = 'highlight-addendum-change'

export function getAllowServiceAddOthersUpdated (currentTender) {
  // check old versions exist or not, if not, return false
  const version = lodash.get(currentTender, 'general.version', 0)
  const hasFirstIssuedVersion = Boolean(currentTender.firstIssuedVersion)
  if (version === 0 || !hasFirstIssuedVersion) return false

  // once changed in addendum, allowServiceAddOthersUpdated will marked as TRUE, and never goes back again
  const updatedInThePast = Boolean(lodash.get(currentTender, 'general.allowServiceAddOthersUpdated'))
  if (updatedInThePast) return true

  // compare with first version, if updated, return true
  const allowOthers = Boolean(lodash.get(currentTender, 'general.allowServiceAddOthers'))
  const firstAllowServiceAddOthers = Boolean(lodash.get(currentTender, 'firstIssuedVersion.data.allowServiceAddOthers'))
  const differentWithFirst = allowOthers !== firstAllowServiceAddOthers

  return differentWithFirst
}

export function getTotalAmount (bidServiceData, totalBeforeDiscount) {
  const discountValue = Number(bidServiceData.discountValue) || 0
  const totalAmount = Number(Math.max(bidServiceData.discountType === discountTypes.PERCENTOFF
    ? totalBeforeDiscount * (1 - (discountValue / 100))
    : totalBeforeDiscount - discountValue, 0).toFixed(2))
  return totalAmount
}

export function getHighlightAllowServiceAddOthers ({currentTender, isAddendum}) {
  if (!isAddendum) return ''

  const updated = getAllowServiceAddOthersUpdated(currentTender)
  if (!updated) return ''

  const allowOthers = lodash.get(currentTender, 'general.allowServiceAddOthers')
  return `${
    ADDENDUM_CLASS_NAME
  }-${
    allowOthers ? addendumChangeType.added : addendumChangeType.removed
  }`
}

export function getTenderServiceOthersTitle () {
  const isRepresentative = store.getters['tenders/isRepresentative']
  const isHKlandUser = store.getters['user/isHKlandUser']
  const i18nPropName = (isRepresentative || isHKlandUser) ? 'unExternalOthers' : 'others'
  return i18n.t(`tender.section.${i18nPropName}`)
}
